function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+d.toUTCString();
  		var path = "path=/";
        document.cookie = cname + "=" + cvalue + "; " + expires + "; " + path;
    } 
    
    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i=0; i<ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1);
            if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
        }
        return "";
    } 
    
    function GetURLParameter(sParam) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] == sParam) {
                return sParameterName[1];
            }
        }
    }
    
    var utm_source = GetURLParameter('utm_source'); 
	var utm_medium = GetURLParameter('utm_medium'); 
	
	
	//console.log(utm_medium);
	if(typeof(utm_medium) != "undefined") {
      utm_medium = utm_medium.toLowerCase();
      
      if(utm_medium == 'ppc' || utm_medium == 'adcense') {  		
          setCookie('psmppc', 'psmedia', 180); 

      }
    }
	//console.log(utm_source);
    if(typeof(utm_source) != "undefined") {
     // Set new cookie value
      	//console.log('condition');
      	//console.log(utm_source);
        setCookie('nonpsmutmsource', utm_source, 1);  
    }

    function gerReferrerUrl() {
        //return document.referrer;  
      if(document.referrer) {
        return document.referrer.match(/:\/\/(.[^/]+)/)[1];
      } else {
       	return 'www.danishdesignstore.com';
      }
    }

	function isPSMCookie(name) {
      var n = name + "=";
      var cookie = document.cookie.split(';');
      for(var i=0;i < cookie.length;i++) {
        var c = cookie[i];
        
        while (c.charAt(0)==' '){c = c.substring(1,c.length);}
        if (c.indexOf(n) == 0){ return true; }
      }
      return false;
    }

	var referrer_url = gerReferrerUrl();
	
	if(typeof(referrer_url) != "undefined" && referrer_url.indexOf('www.danishdesignstore.com') < 0) {
     // Set new referrer_url value
        setCookie('referrer_url', referrer_url, 1);  
    }

	if(utm_medium == 'ppc' && (utm_source == 'bing' || utm_source == 'Bing') && !isPSMCookie('psmaff')) {
      	setCookie('psmaff', 'psmedia', 180);       	
    }



function addCommas(nStr) {
  	nStr = Number(nStr);
  	nStr = nStr.toFixed(2);
    nStr = nStr.toString();
	nStr += '';
	x = nStr.split('.');
	x1 = x[0];
	x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
}

var afterLoad = function(){
  $.ajax({
    url: "/cart.js",
    type: "GET",
    dataType: 'json',
    async: true,
    contentType: "application/json; charset=utf-8",
    crossDomain: true,
    success: function (data) {
      document.getElementById("CartCount").innerHTML = data.item_count;
      document.getElementById("CartCostInner").innerHTML = '$' + addCommas(data.total_price/100);
    },
    error: function (err) {
      console.log(err);
    }
  });
};

$(document).ready(()=> {
  afterLoad('after');
});
